<template>
  <div class="px-input-wrap input-wrap">
    <label>
      <span v-if="!noLabel">
        <slot/>
      </span>
      <input ref="input"
             :type="type"
             v-model="model"
             v-autowidth="autoWidthOptions"
             :placeholder="placeholder"
             class="px-input">
    </label>
  </div>
</template>

<script>
export default {
  name: 'PxInput',
  props: {
    value: String,
    type: { type: String, default: 'text' },
    placeholder: String,
    noLabel: Boolean
  },

  data: () => ({
    defaultMinWidth: 96,
    defaultComfortZone: 12,
    minWidth: 240
  }),

  computed: {
    model: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },

    autoWidthOptions () {
      return {
        maxWidth: '100%',
        minWidth: `${this.minWidth}px`,
        comfortZone: this.defaultComfortZone
      }
    }
  },

  mounted () {
    this.minWidth = this.placeholderWidth()
  },

  watch: {
    placeholder () {
      this.minWidth = this.placeholderWidth()
    }
  },

  methods: {
    focus () {
      this.$refs.input.focus()
    },

    placeholderWidth () {
      if (!this.$refs.input) return
      const val = this.$refs.input.value
      this.$refs.input.value = this.placeholder
      const { width } = window.getComputedStyle(this.$refs.input)
      this.$refs.input.value = val
      return width || this.defaultMinWidth
    }
  }
}
</script>

<style lang="scss">
  @import "../../../../scss/vars";
  .input-wrap {
    max-width: 100%;
    label {
      padding: 0;
    }
    .px-input {
      width: auto;
      min-height: $basic-size;
      padding: 0 $basic-padding;
      margin: 0;
      border: none;
      border-bottom: 1px $px-color-grey dashed;
      background: transparentize(#fff, 0.5);
      font-size: $font-size-body;
      color: $px-color-blue-dark;
      overflow: hidden;
      text-overflow: ellipsis;

      &::placeholder {
        color: transparentize($link-color, 0.1);
        font-style: italic;
      }

      &.compact {
        min-height: unset;
        height: $three-quarters;
      }

      &:focus {
        outline: none;
        color: $link-color;
        background: #fff;
        border-bottom: 1px $link-color dashed;
      }
    }
    &.h2 {
      margin-left: -$basic-padding;
      width: 100%;
      .px-input {
        height: $basic-size + $basic-padding;
        font-size: $h2-font-size;
        //min-width: calc(100% - #{$basic-padding})!important;
      }
    }

    &.big {
      label {
        .px-input {
          min-height: unset;
          height: $basic-size * 1.5;
          font-size: $h2-font-size;
        }
      }
    }
  }
</style>
